<template>
  <div class="modal-container" id="confirmModal">
    <div class="modal-body">
      <h2 class="">
          Edition des informations générale d'un client
      </h2>
      <p>
        {{message}}
      </p>
      <button class="btn btn-success" @click="confirm">
        Confirmer
      </button>
      <button @click="cancel" class="btn">
        Annuler
      </button>
    </div>
  </div>
</template>
<script>
export default {
  name:"ConfirmModal",

  data () {
    return {
      message:"Attention : Vous avez saisi un numéro de TVA intra-communautaire. La saisie de cette information induit des traitements automatiques dans SAP impactant la facturation. Êtes-vous VRAIMENT sûr(e) de vouloir valider les informations saisies ?"
    }
  },

  mounted() {
    $('html, body').animate({
        scrollTop: $("#confirmModal").offset().top
    }, 2000)
  },

  methods:{
    cancel() {
      this.$emit("cancel-edition", true)
    },
    confirm() {
      this.$emit("confirm-edition", true)
    },
  },
}
</script>
<style scoped>
.modal-container {
  height: 101%;
  z-index: 999;
  position: absolute;
  background-color: rgba(0, 0, 0, 0.5);
}

.modal-body {
  background-color: white;
  position: relative;
  margin-top: 20%;
}
</style>



// WEBPACK FOOTER //
// client/components/Customer/InformationsContent/Edit/ConfirmModal.vue